import {Button, Table} from "antd";
import React from "react";
import {FileSearchOutlined} from "@ant-design/icons";
import {useHistory} from "react-router-dom/cjs/react-router-dom.min";

const ShipmentActivitiesTable = ({
    selectedShipmentData,
    transferGroupShipmentLoading,
    page,
    setPage
}) => {
    const history = useHistory();
    const handleShipmentActivityDetail = record => {
        history.push(`/transfers/shipment-activities/${record._id}`);
    };

    return (
        <Table
            dataSource={selectedShipmentData?.shipments}
            rowKey={record => record._id}
            pagination={{
                current: page,
                pageSize: selectedShipmentData?.pagination?.limit || 10,
                total: selectedShipmentData?.pagination?.total,
                onChange: setPage
            }}
            className="transfer-table"
            loading={transferGroupShipmentLoading}
        >
            <Table.Column
                title="Detay"
                dataIndex="detail"
                key="detail"
                render={(detail, record) => (
                    <Button onClick={() => handleShipmentActivityDetail(record)}>
                        <FileSearchOutlined />
                    </Button>
                )}
            />
            <Table.Column
                title="Vigo Barkod Numarası"
                dataIndex="vigoBarcodeNumber"
                key="vigoBarcodeNumber"
            />
            <Table.Column title="Paket Numarası" dataIndex="shipmentNumber" key="shipmentNumber" />
            <Table.Column
                title="Paket Sayısı"
                dataIndex="packageCount"
                key="packageCount"
                render={packageCount => packageCount + " Paket"}
            />
            <Table.Column
                title="Depodan Teslim Alınan Paket Sayısı"
                dataIndex="summary"
                key="summary"
                render={summary =>
                    summary?.receivedCount ? summary?.receivedCount + " Paket" : "0 Paket"
                }
            />
            <Table.Column
                title="Müşteriye Teslim Edilen Paket Sayısı"
                dataIndex="summary"
                key="summary"
                render={summary =>
                    summary?.deliveryCount ? summary?.deliveryCount + " Paket" : "0 Paket"
                }
            />
            <Table.Column
                title="Kayıp Paket Sayısı"
                dataIndex="summary"
                key="summary"
                render={summary =>
                    summary?.missingCount ? summary?.missingCount + " Paket" : "0 Paket"
                }
            />
            <Table.Column
                title="Alıcı Adı"
                dataIndex="receiver"
                key="receiver"
                render={receiver => receiver.name}
            />
            <Table.Column
                title="İl"
                dataIndex="receiver"
                key="receiver"
                render={receiver => receiver.city}
            />
            <Table.Column
                title="İlçe"
                dataIndex="receiver"
                key="receiver"
                render={receiver => receiver.district}
            />
            <Table.Column
                title="Transfer Durumu"
                dataIndex="status"
                key="status"
                render={status =>
                    status === "completed"
                        ? "Tamamlandı"
                        : status === "created"
                        ? "Oluşturuldu"
                        : status === "inTransit"
                        ? "Taşımada"
                        : status === "pending"
                        ? "Beklemede"
                        : status === "inTransit"
                        ? "Taşımada"
                        : "-"
                }
            />
        </Table>
    );
};

export default ShipmentActivitiesTable;
